import { Navigate } from "react-router-dom"
import { Auth } from "../services/Auth"
import { LayoutRouter } from "../pages/layout/Layout"

const PrivateRoutes = () => {
  const isAuthenticated = Auth.isAuthenticated()
  if (!isAuthenticated) Auth.logout()
  return isAuthenticated ? <LayoutRouter /> : <Navigate to="/" replace />
}

export default PrivateRoutes;
